import React from 'react';
import { compose } from 'ramda';
import { makeStyles } from '@material-ui/core';
import {
  reduxForm,
  Form,
  getFormValues,
  InjectedFormProps,
  isValid
} from 'redux-form';
import Store from 'store/store';
import { BoxWrapper, Button } from 'components/Base';

const useStyles = makeStyles({
  modal: {
    width: '320px',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  }
});

const { connect } = Store;

interface ActionModalProps {
  values: any;
  children: any;
  isValid: boolean;
  close: Function;
}

const ActionModal = ({
  handleSubmit,
  values,
  submitting,
  children,
  isValid,
  close
}: InjectedFormProps & ActionModalProps) => {
  const classes = useStyles();
  return (
    <BoxWrapper title={values.title} closeModal={() => close()}>
      <Form onSubmit={handleSubmit} className={classes.modal}>
        <div>{children}</div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="button" color="primary" onClick={() => close()}>
            Cancel
          </Button>
          <Button type="submit" disabled={!isValid} isLoading={submitting}>
            Update
          </Button>
        </div>
      </Form>
    </BoxWrapper>
  );
};

export default compose(
  reduxForm({
    form: 'policyActionType'
  }),
  connect((state: any) => ({
    values: getFormValues('policyActionType')(state),
    isValid: isValid('policyActionType')(state)
  }))
)(ActionModal);
